import styled from 'styled-components'
import css from '@styled-system/css'

const Container = styled.div`
  ${css({
    padding: [3]
  })}
  width: auto;
`

export default Container